import type { Platform } from '@shared/types.ts';

/**
 * Icône d'appareil, dessinée en SVG inline : trois glyphes minuscules ne
 * justifient ni fichier d'icônes ni dépendance.
 */
export default function PlatformIcon({ platform }: { platform: Platform }) {
  const label = platform === 'android' ? 'Android' : platform === 'ios' ? 'Apple' : 'Autre appareil';

  return (
    <svg className="platform-icon" viewBox="0 0 16 16" role="img" aria-label={label} focusable="false">
      {platform === 'android' && (
        <path
          fill="currentColor"
          d="M4.6 6.3h6.8v4.9a.7.7 0 0 1-.7.7H5.3a.7.7 0 0 1-.7-.7zM3.4 6.3c.4 0 .7.3.7.7v3a.7.7 0 0 1-1.4 0V7c0-.4.3-.7.7-.7m9.2 0c.4 0 .7.3.7.7v3a.7.7 0 0 1-1.4 0V7c0-.4.3-.7.7-.7M6.1 12.4h1.2v1.4a.7.7 0 0 1-1.2.5.7.7 0 0 1-.2-.5zm2.6 0h1.2v1.4a.7.7 0 0 1-1.2.5.7.7 0 0 1-.2-.5zM5.9 2.4l.7 1.2a4.6 4.6 0 0 1 2.8 0l.7-1.2a.2.2 0 0 1 .3.2l-.7 1.2c1 .5 1.6 1.4 1.7 2.4H4.6c.1-1 .7-1.9 1.7-2.4l-.7-1.2a.2.2 0 0 1 .3-.2M6.4 5a.4.4 0 1 0 0-.8.4.4 0 0 0 0 .8m3.2 0a.4.4 0 1 0 0-.8.4.4 0 0 0 0 .8"
        />
      )}
      {platform === 'ios' && (
        <path
          fill="currentColor"
          d="M11 8.5c0-1.4 1.1-2.1 1.2-2.2-.7-1-1.7-1.1-2.1-1.1-.9-.1-1.7.5-2.2.5s-1.2-.5-1.9-.5c-1 0-1.9.6-2.4 1.5-1 1.7-.3 4.3.7 5.7.5.7 1.1 1.5 1.9 1.4.7 0 1-.4 1.9-.4s1.1.4 1.9.4c.8 0 1.3-.7 1.8-1.4.6-.8.8-1.6.8-1.6s-1.6-.6-1.6-2.3M9.6 4.2c.4-.5.7-1.2.6-1.9-.6 0-1.3.4-1.7.9-.4.4-.7 1.1-.6 1.8.7 0 1.3-.3 1.7-.8"
        />
      )}
      {platform === 'other' && (
        <path
          fill="currentColor"
          d="M2.5 3.5h11c.3 0 .5.2.5.5v6c0 .3-.2.5-.5.5h-11a.5.5 0 0 1-.5-.5V4c0-.3.2-.5.5-.5m.7 1.2v5.1h9.6V4.7zM1.5 11.8h13a.6.6 0 0 1 0 1.2h-13a.6.6 0 0 1 0-1.2"
        />
      )}
    </svg>
  );
}
